import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MainService } from '../../../services/main.service';

declare const $;

@Component({
  selector: 'app-values-grid',
  templateUrl: './values-grid.component.html',
  styleUrls: ['./values-grid.component.scss']
})
export class ValuesGridComponent implements OnInit {

  mshop_color;

  constructor(private router: Router,
              public mainService: MainService) { }

  ngOnInit() { }

  public goTo(value) {
    this.router.navigate(['/home', { outlets: { 'values': [value] } }]);
    window.scrollTo(0, document.getElementById('values').offsetTop);
  }

}
